module.exports = __webpack_public_path__ + "static/media/m_lipshape_small.8913b4c3.png";